
export const certifications = [

    {
        id: "aws",
        name: "AWS Cloud Practitioner",
        distributor: "Amazon Web Services",
        issued: "12/08/2023",
        expiration: "12/08/2026"
        
    },
    {
        id: "projectPlus",
        name: "Project+",
        distributor: "CompTIA",
        issued: "03/26/2024",
        expiration: null,
        
    },
    {
        id: "itilFour",
        name: "ITIL 4",
        distributor: "People Cert",
        issued: "08/10/2024",
        expiration: "08/10/2027"
        
    }
]
